import { memo } from "react";
import { IconButton, styled } from "@mui/material";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import MxTypography from "@rf-l1/MxTypography";

interface ToggleButtonProps {
  isExpanded: boolean;
  remainingUnits: number;
  onToggle: () => void;
}

const ToggleButton = memo(
  ({ isExpanded, remainingUnits, onToggle }: ToggleButtonProps) => {
    return (
      <ButtonToggle onClick={onToggle} size="small">
        {isExpanded ? (
          <>
            <MxTypography variant="caption" fontWeight={600}>
              Ver menos
            </MxTypography>
            <ArrowDropUpIcon />
          </>
        ) : (
          <>
            <MxTypography variant="caption" fontWeight={600}>
              Ver más ({remainingUnits} unidades)
            </MxTypography>
            <ArrowDropDownIcon />
          </>
        )}
      </ButtonToggle>
    );
  }
);

ToggleButton.displayName = "ToggleButton";

export default ToggleButton;

// Styled Component
const ButtonToggle = styled(IconButton)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "4px",
  color: "var(--m-color-blue-03)",
  "&:hover": {
    backgroundColor: "rgba(25, 118, 210, 0.04)"
  },
  svg: {
    color: "var(--m-color-blue-03)",
    fill: "var(--m-color-blue-03)",
    height: "1.125rem",
    width: "1.125rem"
  }
}));
